// extracted by mini-css-extract-plugin
export var externalLink = "_ax-0";
export var internalLinkLabel = "_ax-1";